import { render } from "./BlogDetails.vue?vue&type=template&id=876066b6"
import script from "./BlogDetails.vue?vue&type=script&lang=js"
export * from "./BlogDetails.vue?vue&type=script&lang=js"

import "./BlogDetails.vue?vue&type=style&index=0&id=876066b6&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__